import { Text } from '@cinesend/ui-kit'

export default function SettingsCard({ title, description, contentClassName, children }) {
  return (
    <section className='flex w-full flex-col gap-4'>
      {title || description ? (
        <div className='flex flex-col gap-1'>
          {title ? (
            <Text as='h2' variant='md-medium'>
              {title}
            </Text>
          ) : null}
          {description ? (
            <Text as='p' variant='sm' tone='secondary'>
              {description}
            </Text>
          ) : null}
        </div>
      ) : null}
      <div
        className={
          contentClassName ??
          'flex w-full flex-col gap-6 rounded-2xl border border-[color:var(--cs-color-border-default)] bg-[var(--cs-color-background-primary)] p-6'
        }
      >
        {children}
      </div>
    </section>
  )
}
